import React, { Component } from 'react';
import { Socket } from 'phoenix';
import QuMap from '@quiqupltd/qu-react-sdk/lib/components/qu-map';
import theme from '@quiqupltd/qu-react-sdk/lib/styles/theme';
import { createFeature } from '@quiqupltd/qu-react-sdk/lib/components/qu-map/qu-map-abstract/qu-map-abstract.helpers';
import QuLoading from '@quiqupltd/qu-react-sdk/lib/components/qu-loading';
import CaseNormaliser from '@quiqupltd/quiqupjs/lib/services/case-normaliser';
import apiClient from '@quiqupltd/quiqupjs/lib/network/api-client';
import get from 'lodash/get';
import { Container, MapWrapper, WarningContainer, BusinessLogoContainer, BusinessLogo } from './styles';
import OrderCard from './order-card/OrderCard';
import Footer from './footer/Footer';
import InvalidToken from './invalid-token/InvalidToken';
import { DROPOFF, WAYPOINT_STATE_FINISHED, WAYPOINT_STATE_PENDING } from '../utils/constants';

const camelNormaliser = new CaseNormaliser(CaseNormaliser.camelCase);
const DROPOFF_PIN = 'https://quiqup-track.s3.amazonaws.com/images/building-pin-white.png';
const FEATURE_OPTIONS = {
  markerText: 'Your order',
  isTrackOrder: true,
};
const LAST_LOCATION_FEED_TIMEOUT = 30000;
let lastCoordinatesTimeout;

export default class App extends Component {
  state = {
    showNoFeedMessage: false,
    order: {
      features: [],
    },
    invalidToken: false,
    lastCoordinatesTimeout: new Date().toISOString(),
    withBounds: true,
    customizations: {},
    isFetching: true, // initial fetching of customizations
  };

  unableWithbounds = () => this.setState({ withBounds: false });

  onNewCourierPosition = () => {
    this.setState({
      showNoFeedMessage: false,
      lastCoordinatesReceivedDate: new Date().toISOString(),
    });

    if (lastCoordinatesTimeout) {
      window.clearTimeout(lastCoordinatesTimeout);
    }

    lastCoordinatesTimeout = window.setTimeout(() => this.setNoFeed(), LAST_LOCATION_FEED_TIMEOUT);
  };

  setNoFeed = () => {
    this.setState(({ lastCoordinatesReceivedDate }) => ({
      showNoFeedMessage: Math.abs(new Date(lastCoordinatesReceivedDate) - new Date()) > LAST_LOCATION_FEED_TIMEOUT,
    }));
  };

  handleJobChannelChange = channel => {
    channel.on('update', updatedData => {
      const data = camelNormaliser.call(updatedData);

      if (data) {
        const { waypoint, numberOfWaypointsAhead } = data;
        this.setState(previousState => {
          if (waypoint.waypointType === DROPOFF) {
            // QuMap - setting customized pin
            waypoint.geoJsonProps = {
              pin: DROPOFF_PIN,
            };
          }
          if (waypoint.state === WAYPOINT_STATE_FINISHED) {
            waypoint.geoJsonProps = {
              color: theme.green,
            };
          }
          // adds the "your order" label to the waypoint, if in correct state
          waypoint.jobState = data.state;

          let features = [];
          features.push(createFeature(waypoint, 'WAYPOINT', FEATURE_OPTIONS));

          this.onNewCourierPosition();

          if (get(data, 'courier.currentLocation.createdAt')) {
            this.setState(
              {
                lastCoordinatesReceivedDate: data.courier.currentLocation.createdAt,
              },
              this.setNoFeed
            );
          }

          const centerLat = parseFloat(get(data, 'region.centerLat'));
          const centerLon = parseFloat(get(data, 'region.centerLon'));
          const mapCenter = centerLat && centerLon ? [centerLat, centerLon] : undefined;
          const availableCourier = !!get(data, 'courier');
          let quiqee = '';

          if (availableCourier) {
            quiqee = {
              img: get(data, 'courier.avatar.thumb.url'),
              name: get(data, 'courier.firstname'),
              transportMode: get(data, 'courier.transportMode'),
              phone: get(data, 'courier.mobile'),
              jobState: get(data, 'state'),
            };
            if (get(data, 'courier.currentLocation.coords')) {
              features.push({
                ...createFeature(
                  {
                    coords: get(data, 'courier.currentLocation.coords'),
                    fullname: get(data, 'courier.firstname'),
                    transportMode: get(data, 'courier.transportMode'),
                    jobState: get(data, 'state'),
                  },
                  'QUIQEE',
                  FEATURE_OPTIONS
                ),
              });
            }
          } else {
            quiqee = null;
          }

          if (!availableCourier) {
            features = features.filter(feature => feature.properties.type !== 'courier');
          }

          return {
            order: {
              numberOfWaypointsAhead,
              jobState: data.state, // this is used to move the markerLabel from one marker to the other
              orderId: data.slug,
              eta: previousState.eta,
              region: data.region,
              kind: data.kind,
              quiqee,
              features,
              waypoint, // passed down to OrderCard
            },
            mapCenter,
          };
        });
      }
    });

    channel.join();
    // if the channel receives an error event, TrackApp will take the user to the invalid token screen
    // if after that the channel sends a valid update event, TrackApp will take the user to the Map screen.
    channel.on('update', () => {
      if (this.state.invalidToken) {
        this.setState({ invalidToken: false });
      }
    });
    channel.on('error', () => {
      this.setState({ invalidToken: true });
    });
  };

  handleWaypointChannelChange = channel => {
    channel.on('update', updatedData => {
      const data = camelNormaliser.call(updatedData);
      const availableQuiqee = get(this.state, 'order.quiqee');

      this.setState(previousState => {
        // dont update the state if the courier position is the same
        const courier = previousState.order.features.find(feature => feature.properties.type === 'courier');
        const isCourierStopped =
          courier &&
          courier.geometry.coordinates[0] === data.coords[0] &&
          courier.geometry.coordinates[1] === data.coords[1];
        if (isCourierStopped) {
          return null;
        }

        // QuMap - Remove Quiqee from the Array to update its location/state
        const features = previousState.order.features.filter(feature => feature.properties.type !== 'courier');
        this.onNewCourierPosition();

        // QuMap - Update the features array with new Quiqee location/state
        if (availableQuiqee) {
          features.push({
            ...createFeature(
              {
                coords: data.coords,
                fullname: get(previousState, 'order.quiqee.name', ''),
                transportMode: get(previousState, 'order.quiqee.transportMode'),
                jobState: get(this.state, 'order.jobState'),
              },
              'QUIQEE',
              FEATURE_OPTIONS
            ),
          });
        }

        return {
          order: {
            ...previousState.order,
            features,
            eta: get(data, 'eta.waypointEstimates[0].estimatedMinutes.value'),
          },
        };
      });
    });

    channel.join();
    // if the channel receives an error event, TrackApp will take the user to the invalid token screen
    // if after that the channel sends a valid update event, TrackApp will take the user to the Map screen.
    channel.on('update', () => {
      if (this.state.invalidToken) {
        this.setState({ invalidToken: false });
      }
    });
    channel.on('error', () => {
      this.setState({ invalidToken: true });
    });
  };

  async componentWillMount() {
    try {
      const TRACKING_TOKEN = window.location.pathname.split('/')[1];
      const customizations = await apiClient.get({
        includeAuth: false,
        path: `${window.env.API_BASE_URL}/partner/settings/via_tracking/${TRACKING_TOKEN}`,
      });

      this.setState({ customizations, isFetching: false });
    } catch (error) {
      // this means it is not a customized partner
      this.setState({ isFetching: false });
    }
  }

  componentDidMount() {
    const TRACKING_TOKEN = window.location.pathname.split('/')[1];
    this.socket = new Socket(window.env.SOCKET_URL, {
      params: {
        tracking_token: TRACKING_TOKEN,
      },
    });

    this.socket.connect();

    const channel1 = this.socket.channel(`tracking:jobs:${TRACKING_TOKEN}`);
    const channel2 = this.socket.channel(`tracking:waypoints:${TRACKING_TOKEN}`);
    this.handleJobChannelChange(channel1);
    this.handleWaypointChannelChange(channel2);
  }

  componentWillUnmount() {
    if (this.socket && this.socket.isConnected()) {
      this.socket.disconnect();
    }
  }

  render() {
    const hasToken = !!window.location.pathname.split('/')[1];
    const { order, invalidToken, mapCenter, showNoFeedMessage, withBounds, isFetching, customizations } = this.state;
    const hasFeatures = order.features.length > 0;
    const isLoading = (hasToken && !hasFeatures) || isFetching;
    const showQuiqeeWarning =
      showNoFeedMessage && hasToken && order.quiqee && order.waypoint.state === WAYPOINT_STATE_PENDING;

    if (isLoading && !invalidToken) {
      return <QuLoading show />;
    }

    return hasToken && !invalidToken ? (
      <Container>
        <MapWrapper>
          {customizations && customizations.logoUrl && (
            <BusinessLogoContainer>
              <BusinessLogo src={customizations.logoUrl} alt={customizations.name} />
            </BusinessLogoContainer>
          )}
          {showQuiqeeWarning && (
            <WarningContainer>
              The connection with your driver has been lost. The location will update ASAP.
            </WarningContainer>
          )}
          <QuMap
            geoJson={hasFeatures && { features: order.features }}
            center={mapCenter}
            withBounds={withBounds}
            maxZoom={18}
            onZoom={this.unableWithbounds}
            onDragend={this.unableWithbounds}
          />
        </MapWrapper>
        <OrderCard order={order} customizations={customizations} />
      </Container>
    ) : (
      <Container>
        <InvalidToken />
        <Footer />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/App.js